/**
 * The practice sandbox behind the Tutorial Center.
 *
 * The server decides the fleet (two quads and a boat); the client only says
 * where. Opening twice returns the sandbox already open, so a remount or a
 * second tab cannot put up a second fleet.
 */

import { api, type ApiResult } from '@/api/client';

export interface PracticeSession {
  droneIds: string[];
  startedAt: number;
  leaseUntil: number;
  leaseRemainingS: number;
}

export interface PracticeState {
  session: PracticeSession | null;
  fleet: string[];
  leaseS: number;
}

export function getPractice(): Promise<ApiResult<PracticeState>> {
  return api.get<PracticeState>('/practice', { logged: false });
}

export function openPractice(lat: number, lon: number): Promise<ApiResult<{ session: PracticeSession }>> {
  return api.post('/practice', { lat, lon }, { label: 'PRACTICE OPEN' });
}

export function renewPractice(): Promise<ApiResult<{ session: PracticeSession }>> {
  return api.post('/practice/renew', undefined, { logged: false });
}

export function closePractice(): Promise<ApiResult<{ removed: string[] }>> {
  return api.delete('/practice', { label: 'PRACTICE END' });
}
